import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private _cookieService: CookieService, private _router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (this._cookieService.get('token')) {
        return true;
      } else {
        this._router.navigateByUrl('/login');
        return false;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/services/auth.guard.ts